import api from "./axios";

// Read endpoints
export const getWalletBalance     = () => api.get("/api/wallet/balance/");
export const getWalletTransactions = (limit = 50) => api.get(`/api/wallet/transactions/?limit=${limit}`);
export const getWalletStorage     = () => api.get("/api/wallet/storage/");
export const getFeatureCost       = (featureCode) => api.get(`/api/wallet/cost-for/${encodeURIComponent(featureCode)}/`);

// Topup catalog (purchase moved to /api/payments/checkout/topup/ —
// imported from payments.api).
export const getTopupPacks   = () => api.get("/api/wallet/topup/packs/");

// Storage management endpoints (purchase moved to
// /api/payments/checkout/subscription/ — storage add-ons are
// recurring subs handled by the same Cashfree flow as main plans).
export const getStorageTiers       = () => api.get("/api/wallet/storage/tiers/");
export const getStorageAddons      = () => api.get("/api/wallet/storage/addons/");
export const cancelStorageAddon    = (subscriptionId) =>
  api.post(`/api/wallet/storage/cancel/${subscriptionId}/`);
export const purgeMatchVideos      = (matchId) =>
  api.post(`/api/matches/matches/${matchId}/purge-videos/`);
